import React from 'react'
import { useState } from 'react'
import SupplyBillAgreeIco from '../../../../supply/supplyBill/view/items/SupplyBillAgreeIco'
import MyModal from '../../../../UI/modal/MyModal'
import AgreeAccountantForm from './AgreeAccountantForm'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';

const AgreeAccountantButton = ({ writeOffActItem }) => {

  	const [open, setOpen] = useState(false)

  return (
    <>
        <SupplyBillAgreeIco
            onClick={e => setOpen(true)}
            text={'Погодження бухгалтером'}
            ico={<PointOfSaleIcon />}
            value={writeOffActItem.isAgreeAccountant}
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження'}
            disableClickOutside={true}
            content={
                <AgreeAccountantForm
                    writeOffActItemBd={writeOffActItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeAccountantButton